import { render, staticRenderFns } from "./section-title.vue?vue&type=template&id=242e0e9c&scoped=true&"
var script = {}
import style0 from "./section-title.vue?vue&type=style&index=0&id=242e0e9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242e0e9c",
  null
  
)

export default component.exports